const MUTATION_TYPE = {
  setCurrentProfession: 'setCurrentProfession',
  setDirections: 'setDirections',
  setProfessions: 'setProfessions',
  setUsersInterestedInProfessions: 'setUsersInterestedInProfessions',
  setAllUsersOlympiadsResults: 'setAllUsersOlympiadsResults'
}

const ACTION_TYPE = {
  fetchCurrentProfession: 'fetchCurrentProfession',
  fetchDirections: 'fetchDirections',
  fetchProfessions: 'fetchProfessions',
  fetchUsersInterestedInProfessions: 'fetchUsersInterestedInProfessions',
  fetchAllUsersOlympiadsResults: 'fetchAllUsersOlympiadsResults'
}

const GETTER_TYPE = {
  getProfessionsList: 'getProfessionsList',
  getProfession: 'getProfession',
  getDirections: 'getDirections',
  getUsersInterestedInProfessions: 'getUsersInterestedInProfessions',
  getAllUsersOlympiadsResults: 'getAllUsersOlympiadsResults'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
